import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../../hooks/useAdminAuth';
import { Users, Shield, Settings, Building } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      try {
        const payload = JSON.parse(atob(adminToken.split('.')[1]));
        setUserRole(payload.role);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('토큰 파싱 오류:', error);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  // 역할별 접근 제어
  const hasAccess = () => {
    if (!requiredRole) return true;
    
    switch (requiredRole) {
      case 'SYSTEM':
        return userRole === 'SYSTEM';
      case 'SUPER_ADMIN':
        return ['SYSTEM', 'SUPER_ADMIN'].includes(userRole);
      case 'DEPT_MANAGER':
        return ['SYSTEM', 'SUPER_ADMIN', 'DEPT_MANAGER'].includes(userRole);
      case 'ADMIN':
        return ['SYSTEM', 'SUPER_ADMIN', 'DEPT_MANAGER', 'ADMIN'].includes(userRole);
      default:
        return true;
    }
  };

  if (loading) {
    return <div>로딩 중...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAccess()) {
    return <div>접근 권한이 없습니다.</div>;
  }

  return children;
};

export default ProtectedRoute;
